document.addEventListener("DOMContentLoaded", function () {
    const menuButtons = document.querySelectorAll("#right-container .menu .item");
    const tabs = document.querySelectorAll("#right-container .right-panel-nav-tab");
    const tabDropdown = document.querySelector('.right-panel-tab-dropdown .tab-dropdown');
    const tabDropdownBtn = document.querySelector('.right-panel-tab-dropdown .tab-dropdown-btn');
    const tabDropdownMenu = document.querySelector('.right-panel-tab-dropdown .tab-dropdown-menu');
    const tabDropdownItems = document.querySelectorAll('.right-panel-tab-dropdown .tab-dropdown-menu .dropdown-item');

    if (__LOG_INFO__) AppLog.info('rightPanel', menuButtons, tabs)
    initializeDefaultChart();
    setListeners();
    setupTabDropdown();

    updateSettingsButtonVisibility(0);

    function setupTabDropdown() {
        if (!tabDropdownBtn || !tabDropdownMenu) return;

        function updateDropdownLabel() {
            const activeTab = document.querySelector('.right-panel-nav-tab.show');
            const activeIndex = Array.from(tabs).indexOf(activeTab);
            const labels = ['Live Chart', 'Performance', 'Profile', 'Financials'];

            const labelElement = tabDropdownBtn.querySelector('.dropdown-label');
            if (labelElement) {
                labelElement.textContent = labels[activeIndex] || 'Live Chart';
            }

            tabDropdownItems.forEach((item, index) => {
                if (index === activeIndex) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        }

        tabDropdownBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            tabDropdown.classList.toggle('active');
        });

        tabDropdownItems.forEach((item, index) => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                switchTab(index);
                tabDropdown.classList.remove('active');
            });
        });

        document.addEventListener('click', (e) => {
            if (!tabDropdown.contains(e.target)) {
                tabDropdown.classList.remove('active');
            }
        });

        updateDropdownLabel();

        const observer = new MutationObserver(() => {
            updateDropdownLabel();
        });

        tabs.forEach(tab => {
            observer.observe(tab, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    }

    function switchTab(index) {
        if (index < 0 || index >= tabs.length) return;

        if (index === 0 && (document.body.dataset.isSearchMode === 'true' || window._searchStockSelected)) {
            document.dispatchEvent(new CustomEvent('close-search-screen'));
            return;
        }

        const rightWrapper = document.querySelector('.right-wrapper');
        if (rightWrapper && rightWrapper.classList.contains('financials-expanded')) {
            rightWrapper.classList.remove('financials-expanded');
            const mainBlock = document.getElementById('main-block');
            if (mainBlock) {
                mainBlock.style.display = '';
            }
            if (window.closeFinancialsExpanded && typeof window.closeFinancialsExpanded === 'function') {
                window.closeFinancialsExpanded();
            }
        }

        menuButtons.forEach(btn => btn.classList.remove("active"));
        tabs.forEach(tab => tab.classList.remove("show"));

        if (menuButtons[index]) {
            menuButtons[index].classList.add("active");
        }
        if (tabs[index]) {
            tabs[index].classList.add("show");
        }

        const labels = ['Live Chart', 'Performance', 'Profile', 'Financials'];
        const dropdownBtn = document.querySelector('.right-panel-tab-dropdown .tab-dropdown-btn');
        const labelElement = dropdownBtn?.querySelector('.dropdown-label');
        if (labelElement) {
            labelElement.textContent = labels[index] || 'Live Chart';
        }

        tabDropdownItems.forEach((item, idx) => {
            if (idx === index) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        updateSettingsButtonVisibility(index);

        const event = new CustomEvent('tab-changed', { detail: { tabIndex: index } });
        document.dispatchEvent(event);

        const prettyGEventName = ['LiveChartTab', 'PerformanceTab', 'ProfileTab', 'FinancialsTab']
        if (window.gtag) gtag('event', `Desktop_RightPanel_${prettyGEventName[index]}`);
    }

    function updateSettingsButtonVisibility(activeTabIndex) {
        const settingsButton = document.querySelector('#right-container .button.settings');
        if (settingsButton) {
            if (activeTabIndex === 0) {
                settingsButton.style.display = 'flex';
            } else {
                settingsButton.style.display = 'none';
            }
        }
    }

    function setListeners() {
        if (!menuButtons || !menuButtons) return


        menuButtons.forEach((currentButton, index) => {
            currentButton.addEventListener("click", () => {
                if (__LOG_INFO__) AppLog.info('click', index, menuButtons, tabs)
                switchTab(index);
            })
        })

        const rightConfigureSettingsButton = document.querySelector('#right-container .button.settings');
        const rightConfigurePopUp = document.querySelector('#right-configure-pop-up');
        const rightConfigurePopUpBg = document.querySelector('#right-configure-pop-up .bg');
        const rightConfigurePopUpCloseButton = document.querySelector('#right-configure-pop-up .close-button');
        rightConfigureSettingsButton?.addEventListener('click', () => {
            if (rightConfigurePopUp) rightConfigurePopUp.classList.add('show');
        })
        rightConfigurePopUpBg?.addEventListener('click', () => {
            if (rightConfigurePopUp) rightConfigurePopUp.classList.remove('show');
        })
        rightConfigurePopUpCloseButton?.addEventListener('click', () => {
            if (rightConfigurePopUp) rightConfigurePopUp.classList.remove('show');
        })

        setupFullscreenButton();

        timeIntervalListener();

        document.body.addEventListener('watchlist-data-loaded', (event) => {
            if (document.body.dataset.isSearchMode === 'true' || window._searchStockSelected) {
                if (__LOG_INFO__) AppLog.info('right-panel: Ignoring watchlist update for chart because Search Mode is active');
                return;
            }

            if (__LOG_INFO__) AppLog.info('right-panel: Watchlist data loaded event received');
            const data = event.detail;
            if (!data || !data.stockInfo) return;

            let firstStock = null;
            if (Array.isArray(data.stockInfo)) {
                if (data.stockInfo.length > 0) {
                    firstStock = data.stockInfo[0];
                }
            } else if (typeof data.stockInfo === 'object') {
                const keys = Object.keys(data.stockInfo);
                if (keys.length > 0) {
                    firstStock = data.stockInfo[keys[0]];
                }
            }

            if (firstStock) {
                const ticker = firstStock.ticker || firstStock.symbol || firstStock.tickerSymbol || firstStock.T;
                if (ticker) {
                    const stockChart = document.getElementById('stock-chart');
                    if (stockChart) {
                        if (__LOG_INFO__) AppLog.info(`right-panel: Updating chart for first stock in watchlist: ${ticker}`);
                        const newStockData = {
                            ticker: ticker,
                            todaysChangePerc: firstStock.todaysChangePerc || firstStock.p || 0,
                            todaysChange: firstStock.todaysChange || 0,
                            tickerDetails: {
                                name: firstStock.name || ticker,
                                primary_exchange: firstStock.exchange || firstStock.primary_exchange || ''
                            }
                        };
                        if (__LOG_INFO__) AppLog.info('[right-panel] About to set stockData on #stock-chart', { ticker, newStockData });
                        stockChart.setAttribute('tradingview-universal-chart', 'stockData', JSON.stringify(newStockData));
                        try {
                            const attrsAfter = stockChart.getAttribute('tradingview-universal-chart');
                            const parentId = stockChart.parentElement ? stockChart.parentElement.id : null;
                            if (__LOG_INFO__) AppLog.info('[right-panel] After stockData set', { parentId, visible: stockChart.getAttribute('visible'), position: stockChart.getAttribute('position'), attrsAfter });
                        } catch (_e) { /* no-op */ }

                        const rightAverageVolumeEl = document.querySelector('#right-average-volume');
                        const rightAverageVolumeBarEl = document.querySelector('#right-average-volume .active-bar');

                        if (rightAverageVolumeEl && rightAverageVolumeBarEl) {
                            const stockVolume = firstStock.daypart_relative_volume_percentage || 0;
                            const width = Math.min(Math.max(0, stockVolume / 2), 100);
                            rightAverageVolumeBarEl.style.width = `${width}%`;
                            rightAverageVolumeEl.classList.add('initialized');

                            const chartData = stockChart.getAttribute('tradingview-universal-chart');
                            const currentInterval = (chartData && chartData.dataInterval) ? chartData.dataInterval : '1D';

                            if (currentInterval === '1D' || currentInterval === '1d') {
                                rightAverageVolumeEl.classList.add('show');
                            } else {
                                rightAverageVolumeEl.classList.remove('show');
                            }
                        }
                    }
                }
            }
        });
    }

    let portraitChartScrollY = 0;
    let isPortraitChartScrollLocked = false;

    function isCoarsePointerDevice() {
        return window.matchMedia('(any-pointer: coarse)').matches ||
            window.matchMedia('(pointer: coarse)').matches ||
            navigator.maxTouchPoints > 0;
    }

    function isMobileDesktopLayout() {
        return document.documentElement.classList.contains('desktop-portrait-accepted') &&
            isCoarsePointerDevice();
    }

    function isDesktopPortraitLayout() {
        return isMobileDesktopLayout() &&
            window.matchMedia('(orientation: portrait)').matches;
    }

    function setMobileRightChartFullscreenFlag(active) {
        document.documentElement.classList.toggle('desktop-right-chart-fullscreen', !!active);
    }

    function ensureLiveChartTabVisible() {
        const liveChartTab = document.querySelector('.live-chart-tab');
        if (!liveChartTab) {
            return;
        }
        tabs.forEach((tab) => tab.classList.remove('show'));
        liveChartTab.classList.add('show');
        menuButtons.forEach((btn, index) => {
            btn.classList.toggle('active', index === 0);
        });
        updateSettingsButtonVisibility(0);
    }

    function scheduleMobileLiveChartResize() {
        const resize = () => window.StockStormDesktopScale?.resizeRightPanelChart?.();
        requestAnimationFrame(() => {
            requestAnimationFrame(resize);
        });
        [80, 200, 450, 750].forEach((delay) => {
            window.setTimeout(resize, delay);
        });
    }

    function setPortraitChartFullscreenScrollLock(lock) {
        if (!isDesktopPortraitLayout()) {
            return;
        }
        if (lock) {
            if (isPortraitChartScrollLocked) {
                return;
            }
            portraitChartScrollY = window.scrollY;
            document.documentElement.classList.add('desktop-right-chart-fullscreen-lock');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${portraitChartScrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            isPortraitChartScrollLocked = true;
            return;
        }
        if (!isPortraitChartScrollLocked) {
            return;
        }
        document.documentElement.classList.remove('desktop-right-chart-fullscreen-lock');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        isPortraitChartScrollLocked = false;
        window.scrollTo(0, portraitChartScrollY);
    }

    function closeRightPanelLiveChartFullscreen() {
        const rightWrapper = document.querySelector('.right-wrapper');
        const mainBlock = document.getElementById('main-block');
        if (!rightWrapper?.classList.contains('financials-expanded')) {
            setMobileRightChartFullscreenFlag(false);
            setPortraitChartFullscreenScrollLock(false);
            return false;
        }
        const financialsTabEl = document.querySelector('.financials-tab.show');
        if (financialsTabEl && window.closeFinancialsExpanded && typeof window.closeFinancialsExpanded === 'function') {
            window.closeFinancialsExpanded();
        } else {
            rightWrapper.classList.remove('financials-expanded');
            if (mainBlock) {
                mainBlock.style.display = '';
            }
        }
        setMobileRightChartFullscreenFlag(false);
        setPortraitChartFullscreenScrollLock(false);
        return true;
    }

    function setupFullscreenButton() {
        const fullScreenBtn = document.querySelector('#right-container .right-panel-tab-dropdown .header-buttons .full-screen');
        if (!fullScreenBtn) return;

        const newBtn = fullScreenBtn.cloneNode(true);
        newBtn.setAttribute('role', 'button');
        newBtn.setAttribute('tabindex', '0');
        fullScreenBtn.parentNode?.replaceChild(newBtn, fullScreenBtn);

        const useClickToggle = isCoarsePointerDevice();
        let isFullscreenLocked = false;

        const handleLiveChartFullscreenClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            window.StockStormMainChartFullscreen?.exit?.();

            if (useClickToggle) {
                toggleRightPanelFullscreen();
                return;
            }

            if (isFullscreenLocked) {
                isFullscreenLocked = false;
                toggleRightPanelFullscreen();
            } else {
                isFullscreenLocked = true;
            }
        };

        newBtn.addEventListener('click', handleLiveChartFullscreenClick, true);

        if (!useClickToggle) {
            newBtn.addEventListener('mouseenter', (e) => {
                e.stopPropagation();
                if (isFullscreenLocked) return;
                const rightWrapper = document.querySelector('.right-wrapper');
                if (rightWrapper && !rightWrapper.classList.contains('financials-expanded')) {
                    toggleRightPanelFullscreen();
                }
            });

            newBtn.addEventListener('mouseleave', (e) => {
                e.stopPropagation();
                if (isFullscreenLocked) return;
                const rightWrapper = document.querySelector('.right-wrapper');
                if (rightWrapper && rightWrapper.classList.contains('financials-expanded')) {
                    toggleRightPanelFullscreen();
                }
            });
        }
    }

    function toggleRightPanelFullscreen() {
        const rightWrapper = document.querySelector('.right-wrapper');
        const mainBlock = document.getElementById('main-block');

        if (!rightWrapper) return;

        const isExpanded = rightWrapper.classList.contains('financials-expanded');
        const financialsTabEl = document.querySelector('.financials-tab.show');
        const isFinancialsTabActive = !!financialsTabEl;
        const hideMainBlockOnExpand = !isDesktopPortraitLayout();

        window._rightPanelTransitioning = true;

        if (isExpanded) {
            if (isFinancialsTabActive && window.closeFinancialsExpanded && typeof window.closeFinancialsExpanded === 'function') {
                window.closeFinancialsExpanded();
            } else {
                rightWrapper.classList.remove('financials-expanded');
                if (mainBlock) {
                    mainBlock.style.display = '';
                }
            }
            setMobileRightChartFullscreenFlag(false);
            setPortraitChartFullscreenScrollLock(false);
        } else {
            window.StockStormMainChartFullscreen?.exit?.();
            if (isDesktopPortraitLayout()) {
                setPortraitChartFullscreenScrollLock(true);
            }
            if (isFinancialsTabActive && !isDesktopPortraitLayout() && window.openFinancialsExpanded && typeof window.openFinancialsExpanded === 'function') {
                window.openFinancialsExpanded();
            } else {
                rightWrapper.classList.add('financials-expanded');
                if (mainBlock && hideMainBlockOnExpand) {
                    mainBlock.style.display = 'none';
                }
            }
            setMobileRightChartFullscreenFlag(isDesktopPortraitLayout());
        }

        setTimeout(() => {
            updateChartSizeForFullscreen();
        }, 150);

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 550);

        if (isDesktopPortraitLayout()) {
            scheduleMobileLiveChartResize();
        }

        setTimeout(() => {
            window._rightPanelTransitioning = false;
        }, 600);
    }

    function updateChartSizeForFullscreen() {
        if (document.getElementById('center-chart-overlay')) return;

        if (isDesktopPortraitLayout()) {
            window.StockStormDesktopScale?.resizeRightPanelChart?.();
            return;
        }
    }

    const rightWrapper = document.querySelector('.right-wrapper');
    if (rightWrapper) {
        const observer = new MutationObserver(() => {
            const expanded = rightWrapper.classList.contains('financials-expanded');
            if (isDesktopPortraitLayout()) {
                setMobileRightChartFullscreenFlag(expanded);
                if (!expanded) {
                    setPortraitChartFullscreenScrollLock(false);
                }
                if (expanded) {
                    scheduleMobileLiveChartResize();
                }
            } else {
                setMobileRightChartFullscreenFlag(false);
            }
            setTimeout(() => {
                updateChartSizeForFullscreen();
            }, 150);
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 550);
        });
        observer.observe(rightWrapper, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    window.toggleRightPanelFullscreen = toggleRightPanelFullscreen;
    window.closeRightPanelLiveChartFullscreen = closeRightPanelLiveChartFullscreen;

    function timeIntervalListener() {
        const intervalButtons = document.querySelectorAll("#right-container .time-range-wrapper .item");
        const rightAverageVolumeEl = document.querySelector('#right-average-volume');
        const stockChart = document.getElementById('stock-chart');

        intervalButtons.forEach((button) => {
            button.addEventListener("click", () => {
                intervalButtons.forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
                const selectedInterval = button.getAttribute("data-range");


                if (__LOG_INFO__) AppLog.info('timeIntervalListener', selectedInterval, stockChart)
                if (!stockChart || !selectedInterval) return;
                stockChart.setAttribute('tradingview-universal-chart', {
                    dataInterval: selectedInterval
                });

                if (rightAverageVolumeEl && rightAverageVolumeEl.classList.contains('initialized')) {
                    if (selectedInterval === '1D') {
                        rightAverageVolumeEl.classList.add('show')
                    } else {
                        rightAverageVolumeEl.classList.remove('show')
                    }
                }
                
                if (window.gtag) gtag('event', `Desktop_RightPanel_LiveChart_TimeLine`, { period: selectedInterval });
            })
        })

        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.addEventListener('data-interval', (e) => {
                if (__LOG_INFO__) AppLog.info('data-interval event received', e)
                if (e.detail && e.detail.interval) {
                    const currentIntervalButtons = document.querySelectorAll("#right-container .time-range-wrapper .item, .search-mode-live-chart-tab .time-range-wrapper .item");
                    currentIntervalButtons.forEach(btn => {
                        if (btn.getAttribute("data-range") === e.detail.interval) btn.classList.add("active")
                        else btn.classList.remove("active")
                    });
                }
            })
            scene.addEventListener('data-interval-dividend', (e) => {
                if (__LOG_INFO__) AppLog.info('data-interval-dividend event received', e)
                if (e.detail && e.detail.interval) {
                    const currentIntervalButtons = document.querySelectorAll("#right-container .time-range-wrapper .item, .search-mode-live-chart-tab .time-range-wrapper .item");
                    currentIntervalButtons.forEach(btn => {
                        if (btn.getAttribute("data-range") === e.detail.interval) btn.classList.add("active")
                        else btn.classList.remove("active")
                    });
                    if (!stockChart) return;
                    stockChart.setAttribute('tradingview-universal-chart', {
                        dataInterval: e.detail.interval
                    });
                }
            })
        }
    }

    function initializeDefaultChart() {
        if (__LOG_INFO__) AppLog.info('initializeDefaultChart',)
        try {
            const stockChart = document.getElementById('stock-chart');
            if (!stockChart) {
                if (__LOG_INFO__) AppLog.info('No default stock-chart found');
                return;
            }

            // const stored = this._loadRightConfigureSettings();
            // const chartType = stored?.chartType || 'mountain';
            // const chartMathFunction = stored?.chartMathFunction || 'Linear';

            const chartType = 'mountain';
            const chartMathFunction = 'Linear';
            if (__LOG_INFO__) AppLog.info('Initializing default chart with type:', chartType, chartMathFunction);
            if (__LOG_INFO__) AppLog.info('[right-panel:init] About to set initial tradingview-universal-chart', { chartType, chartMathFunction });

            stockChart.setAttribute('tradingview-universal-chart', {
                stockData: JSON.stringify({
                    ticker: "SPY",
                    todaysChangePerc: 0.5,
                    day: { c: 20000, v: 1000000 },
                    tickerDetails: {
                        name: "SPDR S&P 500 ETF Trust",
                        primary_exchange: "NYSE"
                    }
                }),
                dataInterval: "1d",
                width: 420,
                height: 285,
                type: chartType,
                chartMathFunction
            });

        } catch (e) {
            if (__LOG_WARN__) AppLog.warn('Failed to initialize default chart:', e);
        }
    }

    function setupDataListeners() {
        const scene = document.querySelector('a-scene');
        if (!scene) return;

        const noDataEl = document.getElementById('no-data-available-message');
        if (!noDataEl) return;

        const noDataText = noDataEl.querySelector('p');

        function handleDataAvailability(hasData) {
            if (hasData) {
                noDataEl.classList.remove('show');
            } else {
                const dateStr = new Intl.DateTimeFormat('en-US', {
                    timeZone: 'America/New_York',
                    month: '2-digit',
                    day: '2-digit'
                }).format(new Date());
                const msg = `${dateStr} data not available yet`;

                if (noDataText) noDataText.textContent = msg;
                noDataEl.classList.add('show');
            }
        }

        scene.addEventListener('chart-data-fetch-complete', (evt) => {
            const { pointCount } = evt.detail;
            handleDataAvailability(pointCount > 0);
        });

        scene.addEventListener('chart-data-fetch-error', () => {
            handleDataAvailability(false);
        });

        scene.addEventListener('chart-data-fetch-started', () => {
            handleDataAvailability(true);
        });
    }

    setupDataListeners();
})
